const INTERNAL_SERVICE_EMAIL_DOMAIN = '@portals.care';

/** CarePortals internal accounts (`*@portals.care`). Gates tenant-configuration writes. */
export function isInternalServiceAccount(email: string): boolean {
  return (email ?? '').toLowerCase().endsWith(INTERNAL_SERVICE_EMAIL_DOMAIN);
}
